/* i18n — libellés injectés par le JS. Repli = chaîne française d'origine
   (donc rendu du marché France strictement inchangé). */
var LPC_JS_FALLBACK = {
  "choose_color": "Choisissez la couleur →",
  "to_configure": "À configurer",
  "charger_hash": "Chargeur #",
  "trio_desc": "Charge simultanée iPhone + Apple Watch + AirPods. Qi2 25W.",
  "solo_desc": "Charge un seul appareil (iPhone). Plus compact, plus minimaliste.",
  "with_warranty": "Avec garantie",
  "without_warranty": "Sans garantie",
  "phone_model_short": "Modèle de téléphone",
  "remove_case": "Retirer une coque",
  "add_case": "Ajouter une coque",
  "without_case": "Sans coque",
  "instal_prefix": "ou ",
  "instal_suffix": "/mois × 3 sans frais via PayPal",
  "add_to_cart": "Ajouter au panier",
  "complete_your_pack": "Compléter votre pack",
  "complete_your_pack_arrow": "Compléter votre pack →",
  "complete_arrow": "Compléter →",
  "build_your_pack": "Composez votre pack",
  "from_price": "À partir de ",
  "see_recap": "Voir le récap →",
  "your_new_charger": "Votre nouveau chargeur.",
  "your_new_chargers": "Vos nouveaux chargeurs.",
  "braided_cable": "Câble USB-C tressé",
  "braided_cable_50": "Câble USB-C tressé 50 cm",
  "engraved_tag": "gravé",
  "warranty_5y_ext": "Garantie 5 ans étendue",
  "custom_engraving": "Gravure personnalisée",
  "prices_updating": "Mise à jour des prix en cours",
  "which_models": "Quels modèles vous faut-il ?",
  "which_model": "Quel modèle vous faut-il ?",
  "protect_chargers": "Protégez vos nouveaux chargeurs.",
  "protect_charger": "Protégez votre nouveau chargeur.",
  "add_error": "Erreur lors de l'ajout au panier."
};
function LPCT(key) {
  var d = (window.LpcI18n && window.LpcI18n.composer) || {};
  var v = d[key];
  return (v === undefined || v === null || v === '') ? (LPC_JS_FALLBACK[key] || '') : v;
}
/* Apple Composer — vanilla JS port of build.html
   Steps: pick formula → fill slots (model + color) → upsells → cart summary.
   State persists in localStorage under "lpc_build". */
(function () {
  if (window.__appleComposerInit) return;
  window.__appleComposerInit = true;

  var fmt = function (n) { return n.toFixed(2).replace('.', ',') + '€'; };
  var loadState = function () {
    try { return JSON.parse(localStorage.getItem('lpc_build')) || null; } catch (e) { return null; }
  };
  var saveState = function (s) { try { localStorage.setItem('lpc_build', JSON.stringify(s)); } catch (e) {} };

  function init() {
    var root = document.querySelector('[data-apple-composer]');
    if (!root) return;
    if (!window.LpcDeliveryWindow) {
      window.addEventListener(
        'lpc:delivery-window-ready',
        function () { render(); },
        { once: true }
      );
    }
    var data;
    try { data = JSON.parse(root.querySelector('[data-composer-data]').textContent); }
    catch (e) { console.error('Composer: invalid data JSON', e); return; }

    var FORMULAS = data.formulas || [];
    var MODELS_TRIO = data.models_trio || [];
    var MODELS_SOLO = data.models_solo || [];
    var POWER = data.power || null;
    var WARRANTY = data.warranty || null;
    var ENGRAVING = data.engraving || null;
    var EXTENSION = data.extension || null;
    var ADAPTER = data.adapter || null;
    var COQUE = data.coque || null;

    // Color name → hex map for known LPC colors. Falls back to a soft gray.
    var COLOR_HEX = {
      'blanc': '#f5f5f7', 'white': '#f5f5f7',
      'noir': '#1d1d1f', 'black': '#1d1d1f',
      'creme': '#e8dcc0', 'crème': '#e8dcc0', 'cream': '#e8dcc0',
      'graphite': '#2a2723',
      'rose': '#d8a8a0', 'pink': '#d8a8a0',
      'sauge': '#8c9a7a', 'vert': '#8c9a7a', 'green': '#8c9a7a',
      'terracotta': '#b8857a',
      'safran': '#c8a878',
      'encre': '#4a5160',
      'argile rose': '#d8a8a0',
      'beige': '#e8ddd0',
      'sable': '#f0e5d0', 'lin': '#f0e5d0'
    };
    function colorHex(name) {
      if (!name) return '#cfcfcf';
      var k = String(name).toLowerCase().trim();
      return COLOR_HEX[k] || '#cfcfcf';
    }

    var initial = loadState() || {};

    // Pre-selection via URL param (?formula=solo|duo|family).
    // Si l'utilisateur arrive depuis la page produit avec une formule
    // déjà choisie, on la sélectionne automatiquement et on saute
    // à l'étape suivante (slots) au render initial.
    var _urlFormula = null;
    try {
      var _qs = new URLSearchParams(window.location.search);
      var _f = (_qs.get('formula') || '').toLowerCase();
      if (_f === 'solo' || _f === 'duo' || _f === 'family' || _f === 'famille') {
        _urlFormula = (_f === 'famille') ? 'family' : _f;
      }
    } catch (e) {}
    var _autoScrollAfterInit = false;
    if (_urlFormula) {
      initial.formula = _urlFormula;
      _autoScrollAfterInit = true;
    }
    // Pre-selection puissance via URL (?power=25w|15w) — depuis les cartes formules PDP.
    try {
      var _qsPow = new URLSearchParams(window.location.search);
      var _pow = (_qsPow.get('power') || '').toLowerCase();
      if (_pow === '25w') initial.power = 'yes';
      else if (_pow === '15w') initial.power = 'no';
    } catch (e) {}

    var state = {
      formula: initial.formula || null,
      slots: initial.slots || [],
      power: initial.power || null,               // 'yes' (25W +19€/chargeur) | 'no' (15W inclus) | null
      warranty: initial.warranty || null,         // 'yes' | 'no' | null
      engraving: initial.engraving || null,       // 'yes' | 'no' | null
      coqueChoice: initial.coqueChoice || null,   // 'with' | 'without' | null
      coqueVariantId: initial.coqueVariantId || null,    // legacy single (solo)
      coqueModelLabel: initial.coqueModelLabel || null,  // legacy single (solo)
      coques: initial.coques || [],   // multi-coque pour Duo/Famille : [{variantId, modelLabel}]
      extras: initial.extras || { extension: 0, adapter: 0, none: false },
      activeIdx: 0,
      modelType: 'trio'
    };

    function persist() {
      saveState({
        formula: state.formula,
        slots: state.slots,
        power: state.power,
        warranty: state.warranty,
        engraving: state.engraving,
        coqueChoice: state.coqueChoice,
        coqueVariantId: state.coqueVariantId,
        coqueModelLabel: state.coqueModelLabel,
        coques: state.coques,
        extras: state.extras
      });
    }

    // ----- DOM refs -----
    var stepFormulaList = root.querySelector('[data-step-formula-list]');
    var stepFormulaCard = root.querySelector('[data-step-formula]');
    var stepFormulaStatus = root.querySelector('[data-step-formula-status]');

    var stepSlotsCard = root.querySelector('[data-step-slots]');
    var stepSlotsTitle = root.querySelector('[data-step-slots-title]');
    var stepSlotsSub = root.querySelector('[data-step-slots-sub]');
    var stepSlotsStatus = root.querySelector('[data-step-slots-status]');
    var slotList = root.querySelector('[data-slot-list]');
    var typeBtns = root.querySelectorAll('[data-model-type]');
    var typeHint = root.querySelector('[data-model-type-hint]');
    var modelGrid = root.querySelector('[data-model-grid]');
    var colorBlock = root.querySelector('[data-color-block]');
    var colorRow = root.querySelector('[data-color-row]');
    var colorTitle = root.querySelector('[data-color-title]');

    var stepPowerCard = root.querySelector('[data-step-power]');
    var stepPowerStatus = root.querySelector('[data-step-power-status]');
    var stepProtectionCard = root.querySelector('[data-step-protection]');
    var stepProtectionStatus = root.querySelector('[data-step-protection-status]');
    var stepCoqueCard = root.querySelector('[data-step-coque]');
    var stepCoqueStatus = root.querySelector('[data-step-coque-status]');
    var stepExtrasCard = root.querySelector('[data-step-extras]');
    var stepExtrasStatus = root.querySelector('[data-step-extras-status]');
    var coqueModelsBlock = root.querySelector('[data-coque-models]');
    var coqueGrid = root.querySelector('[data-coque-grid]');
    var extrasList = root.querySelector('[data-extras-list]');
    var extrasNoneBtn = root.querySelector('[data-extras-none]');

    var summary = root.querySelector('[data-cart-summary]');
    var summaryLines = summary && summary.querySelector('[data-cart-lines]');
    var summaryGift = summary && summary.querySelector('[data-cart-gift]');
    var summaryUpsells = summary && summary.querySelector('[data-cart-upsells]');
    var summaryFormula = summary && summary.querySelector('[data-cart-formula]');
    var summaryDiscount = summary && summary.querySelector('[data-cart-discount]');         // legacy (peut être null)
    var summaryPackDiscount = summary && summary.querySelector('[data-cart-pack-discount]'); // remise pack (Solo=0, Duo/Famille=25%)
    var summaryPromo = summary && summary.querySelector('[data-cart-promo]');                // ligne Pré-Fête (magenta)
    var summaryUpsellTotal = summary && summary.querySelector('[data-cart-upsell-total]');
    var summaryTotal = summary && summary.querySelector('[data-cart-total]');
    var summaryHelp = summary && summary.querySelector('[data-cart-help]');
    var summaryCta = summary && summary.querySelector('[data-cart-cta]');

    // ----- Helpers -----
    function findFormula(id) { return FORMULAS.find(function (f) { return f.id === id; }); }

    function wantedPower() {
      return state.power === 'yes' ? '25W' : '15W';
    }
    function variantPower(v) {
      return (v && v.power) ? v.power : '15W';
    }
    function uniqueColorVariants(variants) {
      var seen = {};
      var out = [];
      (variants || []).forEach(function (v) {
        if (!v || !v.name) return;
        if (!seen[v.name]) {
          seen[v.name] = v;
          out.push(v);
          return;
        }
        // Prefer 15W as the representative color chip
        var cur = seen[v.name];
        if (variantPower(cur) !== '15W' && variantPower(v) === '15W') {
          var idx = out.indexOf(cur);
          seen[v.name] = v;
          if (idx >= 0) out[idx] = v;
        }
      });
      return out;
    }
    function resolveVariant(variants, colorName, power) {
      variants = variants || [];
      power = power || '15W';
      var exactAvail = variants.find(function (v) {
        return v.name === colorName && variantPower(v) === power && v.available;
      });
      if (exactAvail) return exactAvail;
      var exact = variants.find(function (v) {
        return v.name === colorName && variantPower(v) === power;
      });
      if (exact) return exact;
      return variants.find(function (v) { return v.name === colorName; }) || null;
    }
    function syncSlotsToPower() {
      state.slots = (state.slots || []).map(function (s) {
        if (!s || !s.colorName || !s.variants) return s;
        var v = resolveVariant(s.variants, s.colorName, wantedPower());
        if (!v) return s;
        return Object.assign({}, s, {
          variantId: v.id,
          image: v.image || s.image
        });
      });
    }

    function ensureSlots(formula) {
      var f = findFormula(formula);
      if (!f) return [];
      var next = Array(f.qty).fill(null).map(function (_, i) { return state.slots[i] || null; });
      return next;
    }
    function unitCost(opt, qty) {
      if (!opt) return 0;
      if (opt.perUnit) return (opt.price || 0) * qty;
      return opt.price || 0;
    }

    // ----- Renders -----
    function renderFormula() {
      stepFormulaList.innerHTML = '';
      FORMULAS.forEach(function (f) {
        var card = document.createElement('div');
        // Style uniforme pour les 3 formules : pas de class .featured-mini
        // (gradient bg sur Duo) → toutes pareilles, comme Apple.
        card.className = 'formula-card' + (state.formula === f.id ? ' active' : '');
        // Affiche le PRIX FINAL réel (toutes promos appliquées) en gros, avec
        // un breakdown box dessous montrant : prix catalogue → -25% pack
        // (badge bleu) → -30% promo en cours (badge magenta) → prix final.
        // Cohérent : le client voit le prix qu'il va payer, pas de surprise.
        var hasPackDiscount = (f.was || 0) > (f.packPrice || 0) + 0.005;
        var packPct = hasPackDiscount ? Math.round(((f.was - f.packPrice) / f.was) * 100) : 0;
        var preFetePct = (f.packPrice && f.price)
          ? Math.round(((f.packPrice - f.price) / f.packPrice) * 100)
          : 30;
        var perUnit = (f.price || 0) / Math.max(1, f.qty || 1);

        var html = '';
        // Ribbons "Le plus choisi" / "Meilleure valeur" supprimés sur le configurateur :
        // ils restent sur la page produit. Ici on garde 3 cards uniformes.
        html += '<div class="fc-qty">' + f.qty + ' chargeur' + (f.qty > 1 ? 's' : '') + '</div>';
        html += '<div class="fc-name">' + f.name + '</div>';
        // Prix UNIQUE : final en gros (noir) + was barré (gris) sur la même ligne
        html += '<div class="fc-price-main">'
          + '<span class="fc-price-final">' + fmt(f.price) + '</span>'
          + (f.was > f.price + 0.005
              ? '<s class="fc-price-was">' + fmt(f.was) + '</s>'
              : '')
          + '</div>';
        // Mini-badges : -25% pack (bleu) + -30% promo (magenta) — affiche les
        // remises sans dupliquer les prix. Solo : juste le badge promo.
        var badges = '';
        if (hasPackDiscount) {
          badges += '<span class="fcb-mini fcb-mini-pack">'
            + '<span class="fcm-pct">−' + packPct + ' %</span>'
            + '<span class="fcm-label">pack</span>'
            + '</span>';
        }
        // Badge promo uniquement si une promo est réellement appliquée (>0%).
        // Sans promo (packPrice == price), on n'affiche que le badge pack.
        if (preFetePct > 0) {
          badges += '<span class="fcb-mini fcb-mini-promo">'
            + '<span class="fcm-pct">−' + preFetePct + ' %</span>'
            + '<span class="fcm-label">promo</span>'
            + '</span>';
        }
        if (badges) {
          html += '<div class="fc-discount-badges">' + badges + '</div>';
        }
        if (f.qty > 1) {
          html += '<div class="fc-perunit">' + fmt(perUnit) + ' / chargeur</div>';
        }
        card.innerHTML = html;
        card.addEventListener('click', function () {
          state.formula = f.id;
          state.slots = ensureSlots(f.id);
          state.activeIdx = 0;
          persist(); render();
          setTimeout(scrollToFirstIncompleteStep, 250);
        });
        stepFormulaList.appendChild(card);
      });
      var f = findFormula(state.formula);
      if (stepFormulaStatus) stepFormulaStatus.textContent = f ? f.name : '';
      stepFormulaCard.classList.toggle('complete', !!state.formula);
    }

    function slotImage(s) {
      var img = (s && s.image) ? s.image : null;
      if (img) return '<div class="slot-orb slot-orb-img" style="background-image:url(' + img + ');"></div>';
      return '<div class="slot-orb" style="background:#eaeaec;"></div>';
    }

    function buildColorPills(s) {
      var variants = uniqueColorVariants((s && s.variants) || []);
      if (!variants.length) return '';
      var html = '<div class="slot-colors">';
      variants.forEach(function (v) {
        var hex = colorHex(v.name);
        var swStyle = 'background:' + hex + ';' + (hex === '#f5f5f7' ? 'border:1px solid var(--line);' : '');
        // Availability for the chip = any power level of this color available
        var colorAvail = ((s && s.variants) || []).some(function (vv) {
          return vv.name === v.name && vv.available;
        });
        var disabled = colorAvail ? '' : ' is-disabled';
        var active = (s.colorName === v.name) ? ' active' : '';
        html += '<button type="button" class="color-pill' + active + disabled + '" data-color-name="' + v.name.replace(/"/g, '&quot;') + '" aria-label="' + v.name + '"'
          + (colorAvail ? '' : ' disabled')
          + '><span class="sw" style="' + swStyle + '"></span><span>' + v.name + (colorAvail ? '' : ' — épuisé') + '</span></button>';
      });
      html += '</div>';
      return html;
    }

    function renderSlotList() {
      if (!slotList) return;
      slotList.innerHTML = '';
      var f = findFormula(state.formula);
      if (!f) return;
      state.slots.forEach(function (s, i) {
        var hasModel = s && s.modelId;
        var hasColor = s && s.variantId;
        var filled = hasModel && hasColor;
        var row = document.createElement('div');
        row.className = 'model-slot-row' + (i === state.activeIdx ? ' active' : '') + (hasModel ? ' has-model' : '');
        var detail = filled
          ? '<div class="slot-name">' + s.modelName + '</div><div class="slot-meta">' + s.colorName + '</div>'
          : (hasModel
              ? '<div class="slot-name">' + s.modelName + '</div><div class="slot-meta">' + LPCT('choose_color') + '</div>'
              : '<div class="slot-empty-name">' + LPCT('charger_hash') + (i + 1) + '</div><div class="slot-meta">' + LPCT('to_configure') + '</div>');
        // Action label : si rempli → "Modifier", sinon → "Configurer →"
        // (plus de "En cours" qui était ambigu — un slot actif vide doit
        // afficher "Configurer →" pour inviter au click).
        var actionLabel = filled ? 'Modifier' : 'Configurer →';

        var top = '<div class="slot-idx">' + String(i + 1).padStart(2, '0') + '</div>'
          + slotImage(s)
          + '<div class="slot-detail">' + detail + '</div>'
          + '<div class="slot-action">' + actionLabel + '</div>';
        var pills = hasModel ? buildColorPills(s) : '';
        row.innerHTML = top + pills;

        // Color pill clicks
        row.querySelectorAll('[data-color-name]').forEach(function (btn) {
          btn.addEventListener('click', function (ev) {
            ev.stopPropagation();
            var colorName = btn.getAttribute('data-color-name');
            var variants = (s.variants || []);
            var v = resolveVariant(variants, colorName, wantedPower());
            if (!v) return;
            state.slots[i] = Object.assign({}, state.slots[i], {
              variantId: v.id,
              colorName: colorName,
              colorHex: colorHex(colorName),
              image: v.image || state.slots[i].image
            });
            // Auto-advance to next empty slot
            var next = state.slots.findIndex(function (sl, idx) { return idx > i && (!sl || !sl.modelId || !sl.variantId); });
            if (next >= 0) state.activeIdx = next;
            persist(); render();
            // Auto-scroll : si tous les slots remplis → étape Garanties.
            // Sinon → liste des slots pour voir le suivant à configurer.
            setTimeout(function () {
              var allFilled = state.slots.length > 0 && state.slots.every(function (sl) { return sl && sl.modelId && sl.variantId; });
              if (allFilled) {
                scrollToFirstIncompleteStep();
              } else if (slotList) {
                var top = slotList.getBoundingClientRect().top + window.scrollY - 110;
                window.scrollTo({ top: top, behavior: 'smooth' });
              }
            }, 250);
          });
        });

        // Row body click → active ce slot ET scroll vers la grille de modèles
        // (que le slot soit vide "Configurer →" ou rempli "Modifier", le user
        // doit voir où sélectionner après le click).
        row.addEventListener('click', function (ev) {
          if (ev.target.closest('[data-color-name]')) return;
          state.activeIdx = i; render();
          setTimeout(function () {
            var modelGrid = root.querySelector('[data-model-grid]');
            if (modelGrid) {
              var top = modelGrid.getBoundingClientRect().top + window.scrollY - 110;
              window.scrollTo({ top: top, behavior: 'smooth' });
            }
          }, 80);
        });
        slotList.appendChild(row);
      });
    }

    function renderModelTypeButtons() {
      typeBtns.forEach(function (b) {
        var t = b.getAttribute('data-model-type');
        b.classList.toggle('is-active', state.modelType === t);
      });
      if (typeHint) {
        typeHint.textContent = state.modelType === 'trio'
          ? LPCT('trio_desc')
          : LPCT('solo_desc');
      }
    }

    function renderModelGrid() {
      if (!modelGrid) return;
      modelGrid.innerHTML = '';
      var slot = state.slots[state.activeIdx] || {};
      var list = state.modelType === 'trio' ? MODELS_TRIO : MODELS_SOLO;
      if (!list.length) {
        modelGrid.innerHTML = '<p style="color:var(--ink-3);font-size:13px;padding:16px 0;">Aucun produit dans cette collection.</p>';
        return;
      }
      var badgeLabels = {
        bestseller: '★ Best-seller',
        stocklow: 'Stock en baisse',
        rupture: 'Rupture',
        new: 'Nouveau'
      };
      list.forEach(function (m) {
        var c = document.createElement('div');
        var unavailable = m.badge === 'rupture';
        c.className = 'mc' + (slot.modelId === m.id ? ' active' : '') + (unavailable ? ' is-unavailable' : '');
        var badgeHtml = m.badge && badgeLabels[m.badge]
          ? '<span class="mc-badge mc-badge-' + m.badge + '">' + badgeLabels[m.badge] + '</span>'
          : '';
        var visual = m.image
          ? '<img src="' + m.image + '" alt="" class="mc-img" loading="lazy">'
          : '<div class="orb-mini" style="background: radial-gradient(circle at 30% 28%, rgba(255,255,255,0.5) 0%, transparent 50%), #e8dcc0;"></div>';
        c.innerHTML = badgeHtml + visual + '<div class="mc-name">' + m.name + '</div>';
        if (unavailable) {
          c.style.opacity = '0.5';
          c.style.pointerEvents = 'none';
        }
        c.addEventListener('click', function () {
          // Auto-pick the first available variant so the slot is ready.
          // The user can still change the color via the inline pills.
          var colors = uniqueColorVariants(m.variants || []);
          var defaultColor = (colors.find(function (v) {
            return (m.variants || []).some(function (vv) { return vv.name === v.name && vv.available; });
          }) || colors[0] || null);
          var defaultVariant = defaultColor
            ? resolveVariant(m.variants || [], defaultColor.name, state.power ? wantedPower() : '15W')
            : null;
          state.slots[state.activeIdx] = {
            modelId: m.id,
            modelName: m.name,
            type: state.modelType,
            url: m.url,
            image: (defaultVariant && defaultVariant.image) ? defaultVariant.image : m.image,
            variants: m.variants,
            variantId: defaultVariant ? defaultVariant.id : null,
            colorName: defaultColor ? defaultColor.name : null,
            colorHex: defaultColor ? colorHex(defaultColor.name) : null
          };
          // Auto-advance to next empty slot (if any).
          var next = state.slots.findIndex(function (sl, idx) { return idx > state.activeIdx && (!sl || !sl.modelId || !sl.variantId); });
          if (next >= 0) state.activeIdx = next;
          persist();
          render();
          // Auto-scroll : si tous les slots sont remplis, on passe à l'étape
          // suivante (Garanties). Sinon on revient à la liste des slots
          // pour que l'utilisateur voie le slot suivant à configurer.
          setTimeout(function () {
            var allFilled = state.slots.length > 0 && state.slots.every(function (sl) { return sl && sl.modelId && sl.variantId; });
            if (allFilled) {
              scrollToFirstIncompleteStep();
            } else if (slotList) {
              var top = slotList.getBoundingClientRect().top + window.scrollY - 110;
              window.scrollTo({ top: top, behavior: 'smooth' });
            }
          }, 250);
        });
        modelGrid.appendChild(c);
      });
    }

    function renderColorRow() {
      // Colors are now rendered inline in the slot list (renderSlotList).
      // Hide the standalone color block; we keep the function for compatibility.
      if (colorBlock) colorBlock.style.display = 'none';
    }

    // ---- Step 3: Garantie + Gravure (Yes/No each) ----
    function isEngravingFree() {
      return state.formula === 'family';
    }
    function renderProtection() {
      var blocks = root.querySelectorAll('[data-decision]');
      blocks.forEach(function (b) {
        var key = b.getAttribute('data-decision'); // 'warranty' or 'engraving'
        var v = state[key]; // 'yes' | 'no' | null
        b.classList.toggle('is-yes', v === 'yes');
        b.classList.toggle('is-no', v === 'no');
        var yesBtn = b.querySelector('[data-decision-yes]');
        var noBtn = b.querySelector('[data-decision-no]');
        if (yesBtn) yesBtn.classList.toggle('is-active', v === 'yes');
        if (noBtn) noBtn.classList.toggle('is-active', v === 'no');
      });
      // Engraving price label — free for the family pack.
      var engravingLabel = root.querySelector('[data-engraving-price]');
      if (engravingLabel) {
        engravingLabel.innerHTML = isEngravingFree()
          ? '<s style="color:var(--ink-4);font-weight:400;">+9€ par chargeur</s> &nbsp;Offert avec La Famille.'
          : '+9€ par chargeur.';
      }
      // Status — l'UI gravure n'existe plus dans ce step, on n'affiche que
      // l'état de la décision garantie (l'ancien compteur "1/2" restait bloqué).
      if (stepProtectionStatus) {
        stepProtectionStatus.textContent = state.warranty === 'yes' ? LPCT('with_warranty') : (state.warranty === 'no' ? LPCT('without_warranty') : '');
      }
      // Status étape Puissance (même mécanique de décision, step séparé)
      if (stepPowerStatus) {
        stepPowerStatus.textContent = state.power === 'yes' ? '25W' : (state.power === 'no' ? '15W' : '');
      }
    }

    // ---- Step 4: Coque MagSafe — grille unique, chaque clic +1 sur le modèle
    // cliqué. Click répété = +2, +3... Pas de bouton +, pas de max, pas de
    // récap : la grille montre les qty inline et c'est tout.
    function renderCoque() {
      var head = root.querySelector('[data-coque-choice]');
      if (!state.coques) state.coques = [];

      if (head) {
        var withBtn = head.querySelector('[data-coque-with]');
        var withoutBtn = head.querySelector('[data-coque-without]');
        // Ne PAS écraser le textContent : la card a une structure interne
        // (cda-title + cda-desc) définie dans le Liquid. On toggle juste
        // la classe is-active.
        if (withBtn) withBtn.classList.toggle('is-active', state.coqueChoice === 'with');
        if (withoutBtn) withoutBtn.classList.toggle('is-active', state.coqueChoice === 'without');
      }
      if (coqueModelsBlock) coqueModelsBlock.style.display = state.coqueChoice === 'with' ? '' : 'none';

      if (state.coqueChoice === 'with' && coqueModelsBlock && COQUE && COQUE.variants) {
        coqueModelsBlock.innerHTML = '';

        var h = document.createElement('h4');
        h.textContent = LPCT('phone_model_short');
        coqueModelsBlock.appendChild(h);

        var grid = document.createElement('div');
        grid.className = 'coque-model-grid';
        var addCoque = function (v) {
          state.coques.push({ variantId: v.id, modelLabel: v.name });
          state.coqueVariantId = state.coques[0].variantId;
          state.coqueModelLabel = state.coques[0].modelLabel;
          persist(); render();
        };
        var removeCoque = function (v) {
          for (var i = state.coques.length - 1; i >= 0; i--) {
            if (state.coques[i].variantId === v.id) { state.coques.splice(i, 1); break; }
          }
          state.coqueVariantId = state.coques[0] ? state.coques[0].variantId : null;
          state.coqueModelLabel = state.coques[0] ? state.coques[0].modelLabel : null;
          persist(); render();
        };
        COQUE.variants.forEach(function (v) {
          var pickedCount = state.coques.filter(function (c) { return c.variantId === v.id; }).length;
          // Card unique (plus de wrapper externe). Quand sélectionnée :
          // affiche [−] ×N [+] tassés à droite, à l'intérieur du cadre.
          var btn = document.createElement('button');
          btn.type = 'button';
          btn.className = 'coque-card' + (pickedCount > 0 ? ' is-active' : '');
          if (!v.available) btn.disabled = true;
          var inner = '<span class="cc-name">' + v.name + '</span>';
          if (pickedCount > 0) {
            inner += '<span class="cc-stepper">'
              + '<span class="cs-minus" role="button" tabindex="0" aria-label="' + LPCT('remove_case') + '">−</span>'
              + '<span class="cc-qty">×' + pickedCount + '</span>'
              + '<span class="cs-plus" role="button" tabindex="0" aria-label="' + LPCT('add_case') + '">+</span>'
              + '</span>';
          }
          btn.innerHTML = inner;
          // Click sur la card : +1 UNIQUEMENT si pas encore sélectionnée.
          // Une fois sélectionnée, on doit cliquer sur le [+] interne.
          btn.addEventListener('click', function (e) {
            if (e.target.closest('.cs-minus') || e.target.closest('.cs-plus')) return;
            if (pickedCount === 0) addCoque(v);
          });
          // Wire [−] et [+] internes
          var minusEl = btn.querySelector('.cs-minus');
          var plusEl = btn.querySelector('.cs-plus');
          if (minusEl) {
            var doMinus = function (e) { e.stopPropagation(); e.preventDefault(); removeCoque(v); };
            minusEl.addEventListener('click', doMinus);
            minusEl.addEventListener('keydown', function (e) {
              if (e.key === 'Enter' || e.key === ' ') doMinus(e);
            });
          }
          if (plusEl) {
            var doPlus = function (e) { e.stopPropagation(); e.preventDefault(); addCoque(v); };
            plusEl.addEventListener('click', doPlus);
            plusEl.addEventListener('keydown', function (e) {
              if (e.key === 'Enter' || e.key === ' ') doPlus(e);
            });
          }
          grid.appendChild(btn);
        });
        coqueModelsBlock.appendChild(grid);
      }

      // Status
      if (stepCoqueStatus) {
        if (state.coqueChoice === 'without') stepCoqueStatus.textContent = LPCT('without_case');
        else if (state.coqueChoice === 'with') {
          var picked = (state.coques || []).length;
          stepCoqueStatus.textContent = picked > 0 ? (picked + ' coque' + (picked > 1 ? 's' : '')) : '';
        } else stepCoqueStatus.textContent = '';
      }
    }

    // ---- Step 5: Rallonge + Adaptateur ----
    function renderExtras() {
      if (!extrasList) return;
      extrasList.innerHTML = '';
      [EXTENSION, ADAPTER].forEach(function (u) {
        if (!u) return;
        var key = u.id; // 'extension' | 'adapter'
        var qty = state.extras[key] || 0;
        var active = qty > 0;
        var row = document.createElement('div');
        row.className = 'upsell-row' + (active ? ' active' : '');
        var qtyControl = active
          ? '<div data-extras-qty style="margin-top:8px;display:flex;align-items:center;gap:10px;">'
            + '<button data-q="-" style="width:28px;height:28px;border-radius:6px;border:1px solid var(--line);background:#fff;font-size:14px;">−</button>'
            + '<span style="font-family:var(--mono);font-size:13px;min-width:20px;text-align:center;">' + qty + '</span>'
            + '<button data-q="+" style="width:28px;height:28px;border-radius:6px;border:1px solid var(--line);background:#fff;font-size:14px;">+</button>'
            + '</div>'
          : '';
        var cost = u.price * Math.max(1, qty);
        row.innerHTML = '<div class="upsell-info"><h4>' + u.title + '</h4><p>' + u.desc + '</p>' + qtyControl + '</div>'
          + '<div class="upsell-price">+' + fmt(cost) + '</div>';
        row.addEventListener('click', function (ev) {
          if (ev.target.closest('[data-q]')) return;
          state.extras[key] = active ? 0 : 1;
          if (state.extras[key] > 0) state.extras.none = false;
          persist(); render();
        });
        row.querySelectorAll('[data-q]').forEach(function (b) {
          b.addEventListener('click', function (ev) {
            ev.stopPropagation();
            var dir = b.getAttribute('data-q') === '+' ? 1 : -1;
            var cur = Math.max(1, qty);
            var nq = Math.max(1, Math.min(u.maxQty || 10, cur + dir));
            state.extras[key] = nq;
            state.extras.none = false;
            persist(); render();
          });
        });
        extrasList.appendChild(row);
      });
      if (extrasNoneBtn) {
        var isNone = state.extras.none === true;
        extrasNoneBtn.classList.toggle('active', isNone);
      }
      // Status
      if (stepExtrasStatus) {
        if (state.extras.none) stepExtrasStatus.textContent = 'Aucun';
        else {
          var picked = [];
          if (state.extras.extension > 0) picked.push('Rallonge × ' + state.extras.extension);
          if (state.extras.adapter > 0) picked.push('Adaptateur × ' + state.extras.adapter);
          stepExtrasStatus.textContent = picked.join(' · ');
        }
      }
    }

    function renderSummary() {
      if (!summary) return;
      var f = findFormula(state.formula);
      if (!f) { summary.style.display = 'none'; return; }
      summary.style.display = '';

      // Slots
      summaryLines.innerHTML = '';
      state.slots.forEach(function (s, i) {
        var line = document.createElement('div');
        line.className = 'cart-line';
        var orb = (s && s.image)
          ? '<div class="cl-orb cl-orb-img" style="background-image:url(' + s.image + ');"></div>'
          : '<div class="cl-orb" style="background:#eaeaec;"></div>';
        var info = (s && s.modelId)
          ? '<div class="cl-name">' + s.modelName + '</div><div class="cl-meta">' + (s.colorName || 'couleur ?') + '</div>'
          : '<div class="cl-name" style="color:var(--ink-3);">Chargeur #' + (i + 1) + '</div><div class="cl-meta">À configurer</div>';
        line.innerHTML = orb + '<div class="cl-info">' + info + '</div>';
        summaryLines.appendChild(line);
      });

      // Gift
      summaryGift.innerHTML = '';
      if (f.qty >= 2) {
        // Format unifié : "Pack cadeau offert × N" pour Duo (×1) et Famille (×4)
        // "OFFERT" en vert (#198754) pour cohérence avec les autres "Inclus/Offert"
        // — magenta réservé exclusivement à la promo Pré-Fête.
        var giftCount = f.qty === 2 ? 1 : f.qty;
        var giftLabel = 'Pack cadeau offert' + (giftCount > 1 ? ' × ' + giftCount : '');
        summaryGift.innerHTML = '<div class="cart-line">'
          + '<div class="cl-pl" style="color:#198754;font-weight:600;">✦</div>'
          + '<div class="cl-info"><div class="cl-name" style="font-size:13px;">' + giftLabel + '</div>'
          + '<div class="cl-meta">MagSafe + porte-carte + cordon</div></div>'
          + '<div style="font-size:12px;color:#198754;font-weight:600;">OFFERT</div>'
          + '</div>';
      }

      // Extras (power, warranty, engraving, coque, extension, adapter)
      summaryUpsells.innerHTML = '';
      var extrasTotal = 0;
      var lines = [];
      if (state.power === 'yes' && POWER) {
        var cPow = unitCost(POWER, f.qty);
        extrasTotal += cPow;
        lines.push({ title: POWER.title, qty: f.qty, cost: cPow });
      }
      if (state.warranty === 'yes' && WARRANTY) {
        var c = unitCost(WARRANTY, f.qty);
        extrasTotal += c;
        lines.push({ title: WARRANTY.title, qty: f.qty, cost: c });
      }
      if (state.engraving === 'yes' && ENGRAVING) {
        var c2 = isEngravingFree() ? 0 : unitCost(ENGRAVING, f.qty);
        extrasTotal += c2;
        lines.push({ title: ENGRAVING.title + (isEngravingFree() ? ' (offert)' : ''), qty: f.qty, cost: c2 });
      }
      if (state.coqueChoice === 'with' && COQUE) {
        // Shopify price in cents → euros. If already in euros (small number), keep as is.
        var raw = parseFloat(COQUE.price || 1900);
        var coquePrice = raw > 100 ? raw / 100 : raw;
        // Compte les coques sélectionnées (multi pour Duo/Famille).
        var coquesPicked = (state.coques && state.coques.length > 0)
          ? state.coques.filter(function (c) { return c && c.variantId; })
          : (state.coqueVariantId ? [{ variantId: state.coqueVariantId, modelLabel: state.coqueModelLabel }] : []);
        if (coquesPicked.length > 0) {
          var coquesTotalCost = coquePrice * coquesPicked.length;
          extrasTotal += coquesTotalCost;
          if (coquesPicked.length === 1) {
            lines.push({ title: 'Coque MagSafe — ' + (coquesPicked[0].modelLabel || ''), qty: 1, cost: coquesTotalCost });
          } else {
            lines.push({ title: 'Coques MagSafe (' + coquesPicked.length + ')', qty: coquesPicked.length, cost: coquesTotalCost });
          }
        }
      }
      if (state.extras.extension > 0 && EXTENSION) {
        var c3 = (EXTENSION.price || 0) * state.extras.extension;
        extrasTotal += c3;
        lines.push({ title: EXTENSION.title, qty: state.extras.extension, cost: c3 });
      }
      if (state.extras.adapter > 0 && ADAPTER) {
        var c4 = (ADAPTER.price || 0) * state.extras.adapter;
        extrasTotal += c4;
        lines.push({ title: ADAPTER.title, qty: state.extras.adapter, cost: c4 });
      }
      // Pas de détail ligne par ligne dans la sidebar récap — uniquement le
      // total agrégé (ligne "Options +X €" plus bas). Le détail complet est
      // dans le récap final tout en bas (cf-mid "Récapitulatif").
      // (lines[] reste calculé pour computer extrasTotal, mais pas rendu)

      var subtotal = f.price + extrasTotal;
      var savings = f.was - f.price;
      // Détail des réductions :
      //   packDiscount   = was - packPrice (Solo: 0, Duo/Famille: 25%)
      //   preFete        = packPrice - price (~30% pré-Fête des Mères)
      var packPriceVal = parseFloat(f.packPrice || f.was || f.price || 0);
      var packDiscountVal = Math.max(0, (f.was || 0) - packPriceVal);
      var preFeteVal = Math.max(0, packPriceVal - (f.price || 0));

      summaryFormula.querySelector('.label').textContent = f.name + ' (' + f.qty + ' chargeur' + (f.qty > 1 ? 's' : '') + ')';
      var formulaVal = summaryFormula.querySelector('[data-cart-formula-val]');
      if (formulaVal) formulaVal.textContent = fmt(f.was);

      // Ligne remise pack (Solo: hidden, Duo/Famille: visible)
      if (summaryPackDiscount) {
        if (packDiscountVal > 0.005) {
          summaryPackDiscount.style.display = '';
          summaryPackDiscount.querySelector('.label').textContent = 'Remise ' + f.name + ' (−25 %)';
          var packVal = summaryPackDiscount.querySelector('[data-cart-pack-discount-val]');
          if (packVal) packVal.textContent = '−' + fmt(packDiscountVal);
        } else summaryPackDiscount.style.display = 'none';
      }
      // Ligne Fête des Mères (magenta) — visible si réduction > 0
      if (summaryPromo) {
        if (preFeteVal > 0.005) {
          summaryPromo.style.display = '';
          var promoVal = summaryPromo.querySelector('[data-cart-promo-val]');
          if (promoVal) promoVal.textContent = '−' + fmt(preFeteVal);
        } else summaryPromo.style.display = 'none';
      }
      // Legacy : si la ligne 'Économies' existe encore on la cache (remplacée par 2 lignes)
      if (summaryDiscount) summaryDiscount.style.display = 'none';

      summaryUpsellTotal.style.display = extrasTotal > 0 ? '' : 'none';
      if (extrasTotal > 0) {
        var upsellVal = summaryUpsellTotal.querySelector('[data-cart-upsell-total-val]') || summaryUpsellTotal.querySelector('span:last-child');
        if (upsellVal) upsellVal.textContent = '+' + fmt(extrasTotal);
      }
      var totalVal = summaryTotal.querySelector('[data-cart-total-val]') || summaryTotal.querySelector('span:last-child');
      if (totalVal) totalVal.textContent = fmt(subtotal);
      summaryHelp.textContent = journeyText('payment_methods_short', 'Paiement sécurisé · Carte · Shop Pay · Apple Pay · Google Pay');

      // Gating: every step must have an answer
      var slotsComplete = state.slots.length > 0 && state.slots.every(function (s) { return s && s.modelId && s.variantId; });
      var powerDone = !!state.power;
      var protectionDone = !!state.warranty;
      var coqueDone = state.coqueChoice === 'without' || (state.coqueChoice === 'with' && ((state.coques && state.coques.length > 0) || !!state.coqueVariantId));
      var extrasDone = state.extras.none === true || state.extras.extension > 0 || state.extras.adapter > 0;
      var allComplete = slotsComplete && powerDone && protectionDone && coqueDone && extrasDone;

      if (allComplete) {
        summaryCta.textContent = LPCT('add_to_cart');
        summaryCta.classList.remove('is-incomplete');
        summaryCta.disabled = false;
      } else {
        summaryCta.textContent = LPCT('complete_your_pack');
        summaryCta.classList.add('is-incomplete');
        summaryCta.disabled = false; // not disabled — clicking scrolls to next missing step
      }

      // Sticky CTA mobile : quand pack complet → "Ajouter au panier" qui
      // déclenche directement l'ATC (pas juste scroll vers le récap).
      var stickyCta = root.querySelector('[data-sticky-cta]');
      var stickyTotal = root.querySelector('[data-sticky-total]');
      var stickyBtn = root.querySelector('[data-sticky-cta-btn]');
      if (stickyCta && stickyTotal && stickyBtn) {
        stickyCta.style.display = '';
        stickyTotal.textContent = fmt(subtotal);
        stickyBtn.textContent = allComplete ? LPCT('add_to_cart') : LPCT('complete_arrow');
        stickyCta.classList.toggle('is-incomplete', !allComplete);
        stickyCta.classList.toggle('is-ready', allComplete);
      }

      // === Sticky top bar mobile : pack + prix + trust signals + CTA ===
      var stickybarPack = root.querySelector('[data-csb-pack]');
      var stickybarPrice = root.querySelector('[data-csb-price]');
      var stickybarDelivery = root.querySelector('[data-csb-delivery]');
      var stickybarRoot = root.querySelector('[data-composer-stickybar]');
      var stickybarCta = root.querySelector('[data-csb-cta]');
      if (stickybarPack) {
        if (f) {
          var nbStr = f.qty + ' chargeur' + (f.qty > 1 ? 's' : '');
          stickybarPack.textContent = f.name + ' · ' + nbStr;
        } else {
          stickybarPack.textContent = LPCT('build_your_pack');
        }
      }
      if (stickybarPrice) {
        stickybarPrice.textContent = subtotal > 0 ? fmt(subtotal) : LPCT('from_price') + fmt(79.80);
      }
      if (stickybarDelivery) {
        stickybarDelivery.textContent = journeyText('estimated_delivery', 'Livraison estimée') + ' ' + formatDeliveryRange();
      }
      // CTA state : TOUJOURS "Compléter →". Le label change pas, seul le
      // comportement de click change (scroll vers étape ou vers récap final).
      // Disabled si pas encore choisi de formule.
      if (stickybarCta && stickybarRoot) {
        stickybarRoot.dataset.ready = allComplete ? 'true' : 'false';
        stickybarCta.disabled = !f;
        stickybarCta.textContent = LPCT('complete_arrow');
      }
      // Progress dots mobile (6 étapes : formule → modeles → puissance → garantie → coque → accessoires)
      var progressDots = root.querySelectorAll('[data-csb-progress] .csb-progress-dot');
      if (progressDots.length === 6) {
        var stepStates = [
          !!f,                                                                                   // formule
          slotsComplete,                                                                          // modeles
          powerDone,                                                                              // puissance
          protectionDone,                                                                         // garantie
          coqueDone,                                                                              // coque
          extrasDone                                                                              // accessoires
        ];
        // L'étape "active" = la première non-done
        var activeIdx = stepStates.findIndex(function (s) { return !s; });
        progressDots.forEach(function (dot, i) {
          if (stepStates[i]) dot.dataset.state = 'done';
          else if (i === activeIdx) dot.dataset.state = 'active';
          else dot.dataset.state = 'pending';
        });
      }
      // Re-check la visibilité du sticky (ex: après pick formule, position du
      // bottom de la card formule peut avoir changé).
      if (typeof window.__appleComposerCheckSticky === 'function') {
        window.__appleComposerCheckSticky();
      }

      // Side cart CTA: when pack is complete, label becomes "Voir le récap" + scrolls down.
      if (allComplete) {
        summaryCta.textContent = LPCT('see_recap');
      }

      // Final Apple-style recap section
      renderFinal(f, subtotal, savings, allComplete, extrasTotal);
    }

    // ----- Final Apple-style recap (3-column section at bottom) -----
    function journeyText(key, fallback) {
      var dictionary = window.LpcJourneyI18n || {};
      return dictionary[key] || fallback;
    }

    function formatDeliveryRange() {
      if (window.LpcDeliveryWindow) {
        return window.LpcDeliveryWindow.format(
          new Date(),
          document.documentElement.lang || 'fr'
        );
      }
      return '';
    }

    function renderFinal(f, subtotal, savings, allComplete, extrasTotal) {
      extrasTotal = extrasTotal || 0;
      var wrap = root.querySelector('[data-composer-final]');
      if (!wrap) return;
      if (!f) { wrap.style.display = 'none'; return; }
      wrap.style.display = '';

      // Headline : style Apple "Votre nouveau chargeur." (sing) ou "Vos nouveaux chargeurs." (pluriel)
      var headline = root.querySelector('[data-cf-headline]');
      if (headline) {
        headline.textContent = state.slots.length === 1
          ? LPCT('your_new_charger')
          : LPCT('your_new_chargers');
      }

      // Fan of charger images
      var fan = root.querySelector('[data-cf-fan]');
      if (fan) {
        fan.innerHTML = '';
        fan.classList.toggle('cf-fan-solo', state.slots.length === 1);
        state.slots.forEach(function (s, i) {
          var idx = i + 1;
          if (idx > 4) return;
          var img = (s && s.image) ? s.image : null;
          var div = document.createElement('div');
          div.className = 'cf-fan-img fi-' + idx;
          if (img) div.style.backgroundImage = 'url(' + img + ')';
          fan.appendChild(div);
        });
      }

      // Contenu du coffret = récap complet de la commande, avec :
      //   1. tous les chargeurs choisis (nom + couleur)
      //   2. le pack cadeau offert (1 pour Duo, 4 pour Famille) — bonus visible
      //   3. câble USB-C inclus (toujours)
      //   4. coque MagSafe si choisie
      //   5. rallonge / adaptateur si choisis
      var coffret = root.querySelector('[data-cf-coffret]');
      if (coffret) {
        coffret.innerHTML = '';
        state.slots.forEach(function (s, i) {
          if (!s || !s.modelId) return;
          var item = document.createElement('div');
          item.className = 'cf-coffret-item';
          item.innerHTML = (s.image
            ? '<img src="' + s.image + '" alt="">'
            : '<div class="cci-fallback"></div>')
            + '<div class="cci-name">' + (s.modelName || ('Chargeur #' + (i+1))) + '</div>'
            + '<div class="cci-meta">' + (s.colorName || '') + '</div>';
          coffret.appendChild(item);
        });

        // Pack cadeau offert (selon formule : duo = 1, famille = 4)
        // Utilise le vrai produit Shopify si configuré (image + titre),
        // sinon fallback emoji + label par défaut.
        var giftCount = 0;
        if (state.formula === 'duo') giftCount = 1;
        else if (state.formula === 'family') giftCount = 4;
        if (giftCount > 0) {
          var gift = document.createElement('div');
          gift.className = 'cf-coffret-item cf-coffret-gift';
          var giftProduct = window.AppleComposerGift;
          var giftImg = giftProduct && giftProduct.imageUrl
            ? '<img src="' + giftProduct.imageUrl + '" alt="" class="cci-gift-img">'
            : '<div class="cci-fallback cci-gift" aria-hidden="true">🎁</div>';
          var giftName = (giftProduct && giftProduct.title) || 'Pack cadeau offert';
          gift.innerHTML = giftImg
            + '<div class="cci-name">' + giftName + (giftCount > 1 ? ' × ' + giftCount : '') + '</div>';
          coffret.appendChild(gift);
        }

        // Cable USB-C always included — multiplié par nombre de chargeurs
        // Image configurée via theme editor (window.AppleComposerCableImage),
        // sinon fallback gradient gris pour cohérence visuelle.
        var cableQtyCoffret = (state.slots && state.slots.length) || 1;
        var cable = document.createElement('div');
        cable.className = 'cf-coffret-item';
        var cableImg = window.AppleComposerCableImage;
        var cableVisual = cableImg
          ? '<img src="' + cableImg + '" alt="" class="cci-cable-img">'
          : '<div class="cci-fallback" style="background:linear-gradient(180deg,#fff,#f0f0f2);box-shadow:none;border:1px solid var(--line-2);"></div>';
        cable.innerHTML = cableVisual
          + '<div class="cci-name">' + LPCT('braided_cable') + (cableQtyCoffret > 1 ? ' × ' + cableQtyCoffret : '') + '</div>'
          + '<div class="cci-meta">50 cm — inclus</div>';
        coffret.appendChild(cable);

        // Coques (multi) — image du produit Shopify partagée pour toutes les
        // variantes (même image quel que soit le modèle iPhone). Fallback gradient
        // si pas d'image configurée sur le produit Shopify.
        if (state.coqueChoice === 'with') {
          var coquesToShow = (state.coques && state.coques.length > 0)
            ? state.coques
            : (state.coqueModelLabel ? [{ modelLabel: state.coqueModelLabel }] : []);
          var coqueImg = COQUE && COQUE.image;
          coquesToShow.forEach(function (c, ci) {
            if (!c || !c.modelLabel) return;
            var coqueEl = document.createElement('div');
            coqueEl.className = 'cf-coffret-item';
            var coqueVisual = coqueImg
              ? '<img src="' + coqueImg + '" alt="" class="cci-coque-img">'
              : '<div class="cci-fallback" style="background:linear-gradient(180deg,rgba(255,255,255,0.5),rgba(0,0,0,0.04));"></div>';
            coqueEl.innerHTML = coqueVisual
              + '<div class="cci-name">Coque MagSafe' + (coquesToShow.length > 1 ? ' #' + (ci + 1) : '') + '</div>'
              + '<div class="cci-meta">' + c.modelLabel + '</div>';
            coffret.appendChild(coqueEl);
          });
        }
        if (state.extras.extension > 0) {
          var ext = document.createElement('div');
          ext.className = 'cf-coffret-item';
          ext.innerHTML = '<div class="cci-fallback" style="background:#f0f0f2;"></div>'
            + '<div class="cci-name">Rallonge USB-C 1m</div>'
            + '<div class="cci-meta">× ' + state.extras.extension + '</div>';
          coffret.appendChild(ext);
        }
        if (state.extras.adapter > 0) {
          var ad = document.createElement('div');
          ad.className = 'cf-coffret-item';
          ad.innerHTML = '<div class="cci-fallback" style="background:#1d1d1f;"></div>'
            + '<div class="cci-name">Adaptateur 55W</div>'
            + '<div class="cci-meta">× ' + state.extras.adapter + '</div>';
          coffret.appendChild(ad);
        }
        // Toggle mode carousel auto si > 4 items (1 seule ligne PC, swipe + dots).
        // Apple-style : on swipe horizontalement pour voir les autres items.
        var coffretItems = coffret.querySelectorAll('.cf-coffret-item');
        coffret.classList.toggle('cf-coffret--carousel', coffretItems.length > 4);
        // Mobile : régénère les dots du carousel coffret
        if (typeof window.__appleComposerRenderCoffretDots === 'function') {
          window.__appleComposerRenderCoffretDots();
        }
        // Recale la hauteur max du récap sur cf-right (after DOM paint)
        if (typeof window.__appleComposerSyncRecapHeight === 'function') {
          requestAnimationFrame(window.__appleComposerSyncRecapHeight);
        }
      }

      // Récapitulatif text-only ligne par ligne (au milieu du bandeau).
      // Liste TOUT ce qui est dans la commande : chargeurs + couleurs +
      // gravure + garantie + pack cadeau offert + coque(s) + accessoires.
      var recapLines = root.querySelector('[data-cf-recap-lines]');
      if (recapLines) {
        recapLines.innerHTML = '';
        // addLine(label, meta) — meta peut contenir des spans HTML (prix barré + effectif)
        var addLine = function (label, meta, opts) {
          opts = opts || {};
          var li = document.createElement('li');
          li.className = 'cf-recap-line'
            + (opts.free ? ' is-free' : '')
            + (opts.gift ? ' is-gift' : '');
          li.innerHTML = '<span class="crl-label">' + label + '</span>'
            + (meta ? '<span class="crl-meta">' + meta + '</span>' : '');
          recapLines.appendChild(li);
        };
        // Helpers prix
        var perChargeurBase = (f && f.qty) ? (f.was / f.qty) : 0;  // prix de base par chargeur
        var fmtPrice = function (n) { return fmt(n); };

        // Chargeurs : nom + couleur, prix de BASE par chargeur (pas le réduit).
        // Les remises (pack -25 % + pré-fête -30 %) apparaissent dans le
        // breakdown à droite. Ici on reste cohérent avec le sous-total.
        state.slots.forEach(function (s, i) {
          if (!s || !s.modelId) return;
          var label = (s.modelName || ('Chargeur ' + (i + 1)))
            + ' <span class="crl-color">— ' + (s.colorName || '—') + '</span>'
            + (state.engraving === 'yes' ? ' <span class="crl-tag">' + LPCT('engraved_tag') + '</span>' : '');
          addLine(label, '<span class="crl-eff">' + fmtPrice(perChargeurBase) + '</span>');
        });

        // Pack cadeau offert : utilise le titre du vrai produit Shopify si configuré
        var giftN = 0;
        if (state.formula === 'duo') giftN = 1;
        else if (state.formula === 'family') giftN = 4;
        if (giftN > 0) {
          var giftValue = 49 * giftN;
          var giftProductTitle = (window.AppleComposerGift && window.AppleComposerGift.title) || 'Pack cadeau offert';
          var giftLabel = giftProductTitle + (giftN > 1 ? ' <span class="crl-tag">× ' + giftN + '</span>' : '');
          var giftMeta = '<s class="crl-was">' + fmtPrice(giftValue) + '</s> <span class="crl-free">Offert</span>';
          addLine(giftLabel, giftMeta, { gift: true });
        }

        // Câble USB-C inclus : multiplié par le nombre de chargeurs
        var cableQty = (state.slots && state.slots.length) || 1;
        var cableLabel = LPCT('braided_cable_50') + (cableQty > 1 ? ' <span class="crl-tag">× ' + cableQty + '</span>' : '');
        addLine(cableLabel, '<span class="crl-free">Inclus</span>', { free: true });

        // Charge rapide 25W : 19 € × N (sinon 15W incluse, pas de ligne)
        if (state.power === 'yes' && POWER) {
          var powQty = state.slots.length || 1;
          var powTotal = (POWER.price || 19) * powQty;
          addLine(
            'Charge rapide 25W <span class="crl-tag">× ' + powQty + '</span>',
            '+ ' + fmtPrice(powTotal)
          );
        } else if (state.power === 'no') {
          addLine('Charge 15W', '<span class="crl-free">Incluse</span>', { free: true });
        }

        // Garantie 5 ans : 19 € × N (prix WARRANTY constant)
        if (state.warranty === 'yes' && WARRANTY) {
          var packQty = state.slots.length || 1;
          var warrantyTotal = (WARRANTY.price || 19) * packQty;
          addLine(
            LPCT('warranty_5y_ext') + ' <span class="crl-tag">× ' + packQty + '</span>',
            '+ ' + fmtPrice(warrantyTotal)
          );
        }

        // Gravure : 9 € × N OU Offerte (Famille)
        if (state.engraving === 'yes' && ENGRAVING) {
          var engQty = state.slots.length || 1;
          var engTotal = (ENGRAVING.price || 9) * engQty;
          if (isEngravingFree()) {
            addLine(
              LPCT('custom_engraving') + ' <span class="crl-tag">× ' + engQty + '</span>',
              '<s class="crl-was">' + fmtPrice(engTotal) + '</s> <span class="crl-free">Offerte</span>',
              { free: true }
            );
          } else {
            addLine(
              LPCT('custom_engraving') + ' <span class="crl-tag">× ' + engQty + '</span>',
              '+ ' + fmtPrice(engTotal)
            );
          }
        }

        // Coque(s) : 19 € × count
        var coqueArr = state.coques || [];
        if (state.coqueChoice === 'with' && COQUE) {
          var rawCoque = parseFloat(COQUE.price || 1900);
          var coqueUnit = rawCoque > 100 ? rawCoque / 100 : rawCoque;
          if (coqueArr.length > 0) {
            coqueArr.forEach(function (c, ci) {
              if (!c || !c.variantId) return;
              addLine(
                'Coque MagSafe ' + (coqueArr.length > 1 ? '#' + (ci + 1) : '')
                  + ' <span class="crl-color">— ' + (c.modelLabel || '') + '</span>',
                '+ ' + fmtPrice(coqueUnit)
              );
            });
          } else if (state.coqueModelLabel) {
            addLine(
              'Coque MagSafe <span class="crl-color">— ' + state.coqueModelLabel + '</span>',
              '+ ' + fmtPrice(coqueUnit)
            );
          }
        }

        // Rallonge : prix EXTENSION × qty
        if (state.extras.extension > 0 && EXTENSION) {
          var extTotal = (EXTENSION.price || 0) * state.extras.extension;
          addLine(
            'Rallonge USB-C 1 m <span class="crl-tag">× ' + state.extras.extension + '</span>',
            '+ ' + fmtPrice(extTotal)
          );
        }

        // Adaptateur : prix ADAPTER × qty
        if (state.extras.adapter > 0 && ADAPTER) {
          var adTotal = (ADAPTER.price || 0) * state.extras.adapter;
          addLine(
            'Adaptateur secteur 55 W <span class="crl-tag">× ' + state.extras.adapter + '</span>',
            '+ ' + fmtPrice(adTotal)
          );
        }
      }

      // Delivery
      var deliveryEl = root.querySelector('[data-cf-delivery]');
      if (deliveryEl) deliveryEl.textContent = journeyText('estimated_delivery', 'Livraison estimée') + ' — ' + formatDeliveryRange() + '. ' + journeyText('free_over_50', 'Livraison gratuite dès 50 €') + '.';

      // Breakdown récapitulatif (au-dessus du Total) :
      //   Sous-total (was) → Remise pack (was - packPrice) → Pré-Fête (packPrice - price)
      //   → Options/extras → Livraison offerte → Total
      var packPrice = parseFloat(f.packPrice || f.was || f.price || 0);
      var wasPrice = parseFloat(f.was || f.price || 0);
      var basePrice = parseFloat(f.price || 0);
      var packDiscount = Math.max(0, wasPrice - packPrice);     // remise du pack (Solo=0, Duo/Famille=25%)
      var preFeteDiscount = Math.max(0, packPrice - basePrice); // remise pré-fête (~30%)
      var rowSub = root.querySelector('[data-cfb-subtotal]');
      var rowSubVal = root.querySelector('[data-cfb-subtotal-val]');
      var rowPack = root.querySelector('[data-cfb-pack-discount]');
      var rowPackLabel = root.querySelector('[data-cfb-pack-label]');
      var rowPackVal = root.querySelector('[data-cfb-pack-val]');
      var rowPromo = root.querySelector('[data-cfb-promo]');
      var rowPromoVal = root.querySelector('[data-cfb-promo-val]');
      var rowExtras = root.querySelector('[data-cfb-extras]');
      var rowExtrasVal = root.querySelector('[data-cfb-extras-val]');
      if (rowSub && rowSubVal) {
        rowSub.removeAttribute('hidden');
        rowSubVal.textContent = fmt(wasPrice);
      }
      if (rowPack && rowPackVal) {
        if (packDiscount > 0.005) {
          rowPack.removeAttribute('hidden');
          if (rowPackLabel) rowPackLabel.textContent = 'Remise ' + (f.name || 'pack') + ' (−25 %)';
          rowPackVal.textContent = '−' + fmt(packDiscount);
        } else rowPack.setAttribute('hidden', '');
      }
      if (rowPromo && rowPromoVal) {
        if (preFeteDiscount > 0.005) {
          rowPromo.removeAttribute('hidden');
          rowPromoVal.textContent = '−' + fmt(preFeteDiscount);
        } else rowPromo.setAttribute('hidden', '');
      }
      if (rowExtras && rowExtrasVal) {
        if (extrasTotal > 0.005) {
          rowExtras.removeAttribute('hidden');
          rowExtrasVal.textContent = '+' + fmt(extrasTotal);
        } else rowExtras.setAttribute('hidden', '');
      }

      // Total + financing
      var totalEl = root.querySelector('[data-cf-total]');
      var helpEl = root.querySelector('[data-cf-help]');
      if (totalEl) totalEl.textContent = fmt(subtotal);
      if (helpEl) helpEl.textContent = journeyText('payment_methods_short', 'Paiement sécurisé · Carte · Shop Pay · Apple Pay · Google Pay');

      // CTA — toujours reset complet du label à chaque render.
      // Garantie : jamais de "Ajout en cours..." figé après bfcache restore.
      // Pas grisé quand pack incomplet : reste actif noir + flèche, click scroll
      // vers la prochaine étape à compléter (même comportement que sticky top).
      var cfCta = root.querySelector('[data-cf-cta]');
      var cfDisabledNote = root.querySelector('[data-cf-disabled-note]');
      if (cfCta) {
        if (cfCta.dataset.origLabel) delete cfCta.dataset.origLabel;
        cfCta.disabled = false;
        cfCta.classList.remove('is-disabled');
        if (allComplete) {
          cfCta.classList.remove('is-incomplete');
          cfCta.textContent = LPCT('add_to_cart');
        } else {
          cfCta.classList.add('is-incomplete');
          cfCta.textContent = LPCT('complete_your_pack_arrow');
        }
        if (cfDisabledNote) cfDisabledNote.style.display = 'none';
      }
    }

    // Logique : le jour courant = dernier jour de la promo. Promo court du
    // (J-5) au (J). Entre 00h et 04h, transition "Mise à jour des prix".
    // À 04h00, nouvelle plage qui re-glisse.
    var promoBannerEl = root.querySelector('[data-promo-banner]');
    var promoDatesNode = root.querySelector('[data-promo-dates]');
    if (promoBannerEl && promoDatesNode) {
      var MOIS = ['janvier','février','mars','avril','mai','juin',
                  'juillet','août','septembre','octobre','novembre','décembre'];
      var fmtDay = function (d) {
        var day = d.getDate();
        var month = MOIS[d.getMonth()];
        return day + ' ' + month;
      };
      var renderPromoBanner = function () {
        var now = new Date();
        var hour = now.getHours();
        // Mode transition (00h-04h) : pendant cette plage, on affiche
        // "Mise à jour des prix en cours" et on cache les % / dates.
        if (hour < 4) {
          promoBannerEl.dataset.transition = 'true';
          promoDatesNode.textContent = LPCT('prices_updating');
          var line = promoBannerEl.querySelector('.cpm-line');
          if (line) {
            var pct = line.querySelector('.cpm-pct');
            var sep = line.querySelector('.cpm-sep');
            if (pct) pct.style.display = 'none';
            if (sep) sep.style.display = 'none';
          }
          return;
        }
        // Mode normal : promo glissante, J = dernier jour
        promoBannerEl.dataset.transition = 'false';
        var line2 = promoBannerEl.querySelector('.cpm-line');
        if (line2) {
          var pct2 = line2.querySelector('.cpm-pct');
          var sep2 = line2.querySelector('.cpm-sep');
          if (pct2) pct2.style.display = '';
          if (sep2) sep2.style.display = '';
        }
        var endDate = new Date(now.getFullYear(), now.getMonth(), now.getDate());
        var startDate = new Date(endDate);
        startDate.setDate(endDate.getDate() - 5);
        // Format : "du 22 au 27 avril" ou "du 28 avril au 3 mai" si chevauche mois
        var sameMonth = startDate.getMonth() === endDate.getMonth();
        var label = sameMonth
          ? 'Du ' + startDate.getDate() + ' au ' + fmtDay(endDate)
          : 'Du ' + fmtDay(startDate) + ' au ' + fmtDay(endDate);
        promoDatesNode.textContent = label;
      };
      renderPromoBanner();
      // Re-check toutes les 5 min pour gérer le passage 03h59 → 04h00 et
      // le passage 23h59 → 00h00 sans avoir à reload la page.
      setInterval(renderPromoBanner, 5 * 60 * 1000);
    }

    // ----- Bloc urgency sous le bandeau récap : tuiles calendrier + countdown -----
    // Tuile gauche = J-5 (début promo), tuile droite = J (dernier jour, fin promo).
    // Plus : injection date Fête des Mères dynamique (dernier dim. de mai sauf
    // si Pentecôte → 1er dim. de juin) + nombre de jours restants.
    // Pendant 00h-04h : data-transition="true" → tuiles cachées, message transition.
    var urgencyEl = root.querySelector('[data-final-urgency]');
    var urgencyCountdownNode = root.querySelector('[data-cfu-countdown]');
    var urgencyStartDay = root.querySelector('[data-cfu-start-day]');
    var urgencyStartMonth = root.querySelector('[data-cfu-start-month]');
    var urgencyEndDay = root.querySelector('[data-cfu-end-day]');
    var urgencyEndMonth = root.querySelector('[data-cfu-end-month]');
    // Paragraphe éditable via theme editor : on stocke le template original
    // pour pouvoir réinjecter [date]/[days] à chaque tick (sinon on perd les
    // placeholders après le 1er render).
    var urgencyTagline = urgencyEl ? urgencyEl.querySelector('.cfu-tagline') : null;
    if (urgencyTagline && !urgencyTagline.dataset.template) {
      urgencyTagline.dataset.template = urgencyTagline.textContent.trim();
    }
    if (urgencyEl) {
      var MOIS_SHORT = ['janv.','févr.','mars','avr.','mai','juin',
                        'juil.','août','sept.','oct.','nov.','déc.'];
      var MOIS_LONG = ['janvier','février','mars','avril','mai','juin',
                       'juillet','août','septembre','octobre','novembre','décembre'];
      // Algorithme de Meeus/Jones/Butcher pour la date de Pâques
      var computeEaster = function (year) {
        var a = year % 19;
        var b = Math.floor(year / 100);
        var c = year % 100;
        var d = Math.floor(b / 4);
        var e = b % 4;
        var f = Math.floor((b + 8) / 25);
        var g = Math.floor((b - f + 1) / 3);
        var h = (19 * a + b - d - g + 15) % 30;
        var i = Math.floor(c / 4);
        var k = c % 4;
        var L = (32 + 2 * e + 2 * i - h - k) % 7;
        var m = Math.floor((a + 11 * h + 22 * L) / 451);
        var month = Math.floor((h + L - 7 * m + 114) / 31);
        var day = ((h + L - 7 * m + 114) % 31) + 1;
        return new Date(year, month - 1, day);
      };
      // Fête des Mères FR : dernier dim. de mai, sauf si Pentecôte → 1er dim. juin
      var computeFeteDesMeres = function (year) {
        var lastSundayMay = new Date(year, 4, 31);
        while (lastSundayMay.getDay() !== 0) {
          lastSundayMay.setDate(lastSundayMay.getDate() - 1);
        }
        var easter = computeEaster(year);
        var pentecost = new Date(easter.getFullYear(), easter.getMonth(), easter.getDate() + 49);
        if (lastSundayMay.getTime() === pentecost.getTime()) {
          var firstSundayJune = new Date(year, 5, 1);
          while (firstSundayJune.getDay() !== 0) {
            firstSundayJune.setDate(firstSundayJune.getDate() + 1);
          }
          return firstSundayJune;
        }
        return lastSundayMay;
      };
      var renderUrgencyBlock = function () {
        var now = new Date();
        var hour = now.getHours();
        // Plage transition 00h-04h
        if (hour < 4) {
          urgencyEl.dataset.transition = 'true';
          if (urgencyCountdownNode) urgencyCountdownNode.textContent = '';
          return;
        }
        urgencyEl.dataset.transition = 'false';
        // Dates promo glissante : J = aujourd'hui = dernier jour, début = J-5
        var endDate = new Date(now.getFullYear(), now.getMonth(), now.getDate());
        var startDate = new Date(endDate);
        startDate.setDate(endDate.getDate() - 5);
        if (urgencyStartDay) urgencyStartDay.textContent = startDate.getDate();
        if (urgencyStartMonth) urgencyStartMonth.textContent = MOIS_SHORT[startDate.getMonth()];
        if (urgencyEndDay) urgencyEndDay.textContent = endDate.getDate();
        if (urgencyEndMonth) urgencyEndMonth.textContent = MOIS_SHORT[endDate.getMonth()];
        // Fête des Mères : choisit l'année courante si pas encore passée, sinon n+1
        var fdmYear = now.getFullYear();
        var fdm = computeFeteDesMeres(fdmYear);
        if (fdm < endDate) {
          fdm = computeFeteDesMeres(fdmYear + 1);
        }
        var fdmDateStr = fdm.getDate() + ' ' + MOIS_LONG[fdm.getMonth()];
        var daysUntilMom = Math.ceil((fdm - endDate) / 86400000);
        var fdmDaysStr = daysUntilMom + (daysUntilMom > 1 ? ' jours' : ' jour');
        // Substitue [date] et [days] dans le paragraphe éditable
        if (urgencyTagline && urgencyTagline.dataset.template) {
          urgencyTagline.textContent = urgencyTagline.dataset.template
            .replace(/\[date\]/g, fdmDateStr)
            .replace(/\[days\]/g, fdmDaysStr);
        }
        // Countdown jusqu'à minuit
        if (urgencyCountdownNode) {
          var midnight = new Date(now); midnight.setHours(24, 0, 0, 0);
          var ms = midnight - now;
          var h = Math.floor(ms / 3600000);
          var m = Math.floor((ms % 3600000) / 60000);
          urgencyCountdownNode.textContent = 'plus que ' + h + ' h ' + (m < 10 ? '0' + m : m) + ' min';
        }
      };
      renderUrgencyBlock();
      setInterval(renderUrgencyBlock, 60 * 1000);
    }

    function render() {
      if (state.formula) state.slots = ensureSlots(state.formula);

      var f = findFormula(state.formula);
      var formulaComplete = !!f;
      var slotsComplete = formulaComplete && state.slots.length > 0
        && state.slots.every(function (s) { return s && s.modelId && s.variantId; });
      var powerDone = !!state.power;
      var protectionDone = !!state.warranty;
      var coqueDone = state.coqueChoice === 'without' || (state.coqueChoice === 'with' && ((state.coques && state.coques.length > 0) || !!state.coqueVariantId));
      var extrasDone = state.extras.none === true || state.extras.extension > 0 || state.extras.adapter > 0;

      // Step gating
      stepSlotsCard.classList.toggle('disabled', !formulaComplete);
      stepSlotsCard.classList.toggle('complete', slotsComplete);
      if (stepPowerCard) {
        stepPowerCard.classList.toggle('disabled', !slotsComplete);
        stepPowerCard.classList.toggle('complete', powerDone);
      }
      if (stepProtectionCard) {
        stepProtectionCard.classList.toggle('disabled', !slotsComplete || !powerDone);
        stepProtectionCard.classList.toggle('complete', protectionDone);
      }
      if (stepCoqueCard) {
        stepCoqueCard.classList.toggle('disabled', !slotsComplete || !powerDone || !protectionDone);
        stepCoqueCard.classList.toggle('complete', coqueDone);
      }
      if (stepExtrasCard) {
        stepExtrasCard.classList.toggle('disabled', !slotsComplete || !powerDone || !protectionDone || !coqueDone);
        stepExtrasCard.classList.toggle('complete', extrasDone);
      }

      // Step 2 : titre eyebrow Apple-style avec singulier / pluriel selon le pack.
      // Solo  → "Modèle." / "Quel modèle vous faut-il ?"
      // Duo+  → "Modèles." / "Quels modèles vous faut-il ?"
      if (f && f.qty > 1) {
        stepSlotsTitle.textContent = 'Modèles.';
        stepSlotsSub.textContent = LPCT('which_models');
      } else {
        stepSlotsTitle.textContent = 'Modèle.';
        stepSlotsSub.textContent = LPCT('which_model');
      }
      // Step 3 Garantie : sous-titre singulier/pluriel (sur tous les éléments matchant)
      var protectionSubEls = root.querySelectorAll('[data-step-protection-sub]');
      var protectionSubText = (f && f.qty > 1)
        ? LPCT('protect_chargers')
        : LPCT('protect_charger');
      protectionSubEls.forEach(function (el) { el.textContent = protectionSubText; });
      var filled = state.slots.filter(function (s) { return s && s.modelId && s.variantId; }).length;
      if (stepSlotsStatus) stepSlotsStatus.textContent = formulaComplete ? (filled + '/' + state.slots.length) : '';

      renderFormula();
      renderSlotList();
      renderModelTypeButtons();
      renderModelGrid();
      renderColorRow();
      renderProtection();
      renderCoque();
      renderExtras();
      renderSummary();
    }

    // ----- Decision wiring (static HTML buttons) -----
    root.querySelectorAll('[data-decision] [data-decision-yes]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var key = btn.closest('[data-decision]').getAttribute('data-decision');
        state[key] = 'yes';
        if (key === 'power') syncSlotsToPower();
        persist(); render();
        setTimeout(scrollToFirstIncompleteStep, 250);
      });
    });
    root.querySelectorAll('[data-decision] [data-decision-no]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var key = btn.closest('[data-decision]').getAttribute('data-decision');
        state[key] = 'no';
        if (key === 'power') syncSlotsToPower();
        persist(); render();
        setTimeout(scrollToFirstIncompleteStep, 250);
      });
    });

    var coqueWithBtn = root.querySelector('[data-coque-with]');
    var coqueWithoutBtn = root.querySelector('[data-coque-without]');
    if (coqueWithBtn) coqueWithBtn.addEventListener('click', function () {
      state.coqueChoice = 'with';
      persist(); render();
    });
    if (coqueWithoutBtn) coqueWithoutBtn.addEventListener('click', function () {
      state.coqueChoice = 'without';
      state.coqueVariantId = null;
      state.coqueModelLabel = null;
      persist(); render();
      setTimeout(scrollToFirstIncompleteStep, 250);
    });

    if (extrasNoneBtn) extrasNoneBtn.addEventListener('click', function () {
      state.extras = { extension: 0, adapter: 0, none: true };
      persist(); render();
      setTimeout(scrollToFinal, 250);
    });

    var stickyCtaBtn = root.querySelector('[data-sticky-cta-btn]');
    if (stickyCtaBtn) stickyCtaBtn.addEventListener('click', function () {
      // Si pack complet (is-ready) → déclenche directement l'ATC final
      // (équivalent au bouton "Ajouter au panier" du récap final).
      var stickyCtaWrap = root.querySelector('[data-sticky-cta]');
      if (stickyCtaWrap && stickyCtaWrap.classList.contains('is-ready')) {
        var finalCta = root.querySelector('[data-cf-cta]');
        if (finalCta && !finalCta.disabled) { finalCta.click(); return; }
      }
      if (summaryCta) summaryCta.click();
    });

    // === Sticky top bar mobile : reveal après scroll passé la section Formule ===
    // Apparaît UNIQUEMENT si une formule a été choisie ET que l'utilisateur a
    // scrollé en dessous de la section "Formule." (= bottom de step-formula).
    // Cache au top de page pour ne pas chevaucher le hero/promo strip.
    var stickybarEl = root.querySelector('[data-composer-stickybar]');
    if (stickybarEl) {
      var revealStickyOnScroll = function () {
        var f = findFormula(state.formula);
        var formulaCard = root.querySelector('[data-step-formula]');
        if (!f || !formulaCard) {
          stickybarEl.dataset.revealed = 'false';
          return;
        }
        var formulaBottom = formulaCard.getBoundingClientRect().bottom + window.scrollY;
        var shouldReveal = window.scrollY > formulaBottom - 80;
        stickybarEl.dataset.revealed = shouldReveal ? 'true' : 'false';
      };
      window.addEventListener('scroll', revealStickyOnScroll, { passive: true });
      window.addEventListener('resize', revealStickyOnScroll, { passive: true });
      // Recheck au prochain frame (après que renderAll a placé l'élément)
      requestAnimationFrame(revealStickyOnScroll);
      // Expose pour appels manuels (après pick formule par ex.)
      window.__appleComposerCheckSticky = revealStickyOnScroll;
    }

    // === Bouton CTA dans le sticky top : TOUJOURS "Compléter →" ===
    // Le bouton ne fait JAMAIS l'ATC direct. Il scroll vers la prochaine
    // étape incomplete OU, quand tout est complet, vers le récap final
    // ("Vos nouveaux chargeurs selon vos préférences"). C'est dans ce
    // récap que le client clique "Ajouter au panier".
    var stickybarCtaBtn = root.querySelector('[data-csb-cta]');
    if (stickybarCtaBtn) {
      stickybarCtaBtn.addEventListener('click', function () {
        if (stickybarCtaBtn.disabled) return;
        // Si tout est complet → scroll directement vers le bouton "Ajouter
        // au panier" du récap final (data-cf-cta), pas vers le bandeau "30
        // jours" qui est en haut. Le user voit le bouton ATC en bas de viewport.
        if (stickybarEl && stickybarEl.dataset.ready === 'true') {
          var ctaBtn = root.querySelector('[data-cf-cta]');
          if (ctaBtn) {
            var rect = ctaBtn.getBoundingClientRect();
            // Centre le bouton ATC dans le viewport (en bas)
            var top = rect.top + window.scrollY - (window.innerHeight - rect.height - 40);
            window.scrollTo({ top: Math.max(0, top), behavior: 'smooth' });
            return;
          }
          // Fallback : scroll vers composer-final-inner (Vos nouveaux chargeurs)
          var innerEl = root.querySelector('.composer-final-inner');
          if (innerEl) {
            var topInner = innerEl.getBoundingClientRect().top + window.scrollY - 80;
            window.scrollTo({ top: topInner, behavior: 'smooth' });
            return;
          }
        }
        // Sinon → scroll vers la prochaine étape incomplete
        scrollToFirstIncompleteStep();
      });
    }

    // === Carousel dots : 1 dot par "page" d'items visibles (Apple-style) ===
    // 5 items / 4 visibles → 2 dots ; 8 / 4 → 2 dots ; 9 / 4 → 3 dots.
    // Scroll mappé linéairement de 0 → max sur l'index du dot actif, donc
    // scroll all-the-way-right active toujours le dernier dot.
    function renderCoffretDots() {
      var coffret = root.querySelector('[data-cf-coffret]');
      if (!coffret) return;
      var dotsEl = root.querySelector('[data-cf-coffret-dots]');
      if (!dotsEl) return;
      var items = coffret.querySelectorAll('.cf-coffret-item');
      dotsEl.innerHTML = '';
      if (items.length <= 1) return;

      // Combien d'items rentrent dans le viewport horizontal (page = N items)
      function getItemsPerPage() {
        if (!items.length) return 1;
        var itemW = items[0].offsetWidth;
        if (itemW <= 0) return 4;
        var gap = 8; // gap CSS du carousel
        var fits = Math.floor((coffret.clientWidth + gap) / (itemW + gap));
        return Math.max(1, fits);
      }

      var itemsPerPage = getItemsPerPage();
      var numDots = Math.max(1, Math.ceil(items.length / itemsPerPage));
      // 1 seule page = pas de dots utiles
      if (numDots <= 1) return;

      for (var i = 0; i < numDots; i++) {
        var dot = document.createElement('span');
        dot.className = 'ccd-dot' + (i === 0 ? ' is-active' : '');
        dotsEl.appendChild(dot);
      }

      var raf = null;
      coffret.addEventListener('scroll', function () {
        if (raf) cancelAnimationFrame(raf);
        raf = requestAnimationFrame(function () {
          var maxScroll = coffret.scrollWidth - coffret.clientWidth;
          var progress = maxScroll <= 0 ? 0 : (coffret.scrollLeft / maxScroll);
          var activeIdx = Math.round(progress * (numDots - 1));
          if (activeIdx < 0) activeIdx = 0;
          if (activeIdx > numDots - 1) activeIdx = numDots - 1;
          dotsEl.querySelectorAll('.ccd-dot').forEach(function (d, i) {
            d.classList.toggle('is-active', i === activeIdx);
          });
        });
      }, { passive: true });
    }
    // Re-render dots à chaque update du coffret. On expose via window pour que
    // renderFinal puisse l'appeler à la fin.
    window.__appleComposerRenderCoffretDots = renderCoffretDots;

    // No-op : la liste récap n'est plus cappée. Elle s'étend librement,
    // cf-left + cf-right alignés en top dans la grille. Évite tout
    // scrollbar parasite + tout "espace vide" lié à un max-height mal calé.
    function syncRecapMaxHeight() {
      var recapLines = root.querySelector('[data-cf-recap-lines]');
      if (recapLines) recapLines.style.maxHeight = '';
    }
    window.__appleComposerSyncRecapHeight = syncRecapMaxHeight;

    function scrollToFirstIncompleteStep() {
      var f = findFormula(state.formula);
      var slotsComplete = !!f && state.slots.length > 0 && state.slots.every(function (s) { return s && s.modelId && s.variantId; });
      var powerDone = !!state.power;
      var protectionDone = !!state.warranty;
      var coqueDone = state.coqueChoice === 'without' || (state.coqueChoice === 'with' && ((state.coques && state.coques.length > 0) || !!state.coqueVariantId));
      var extrasDone = state.extras.none === true || state.extras.extension > 0 || state.extras.adapter > 0;
      var target = null;
      if (!f) target = root.querySelector('[data-step-formula]');
      else if (!slotsComplete) target = root.querySelector('[data-step-slots]');
      else if (!powerDone) target = stepPowerCard;
      else if (!protectionDone) target = stepProtectionCard;
      else if (!coqueDone) target = stepCoqueCard;
      else if (!extrasDone) target = stepExtrasCard;
      if (!target) return;
      var top = target.getBoundingClientRect().top + window.scrollY - 110;
      window.scrollTo({ top: top, behavior: 'smooth' });
    }

    // Type toggle handlers
    typeBtns.forEach(function (b) {
      b.addEventListener('click', function () {
        state.modelType = b.getAttribute('data-model-type');
        render();
      });
    });

    function addPackToCart(triggerBtn) {
      var redirect = root.getAttribute('data-cart-url') || '/cart';
      var items = [];

      state.slots.forEach(function (s) {
        if (!s || !s.colorName) return;
        var powerLabel = state.power === 'yes' ? '25W' : '15W';
        var resolved = resolveVariant(s.variants || [], s.colorName, powerLabel) || (s.variantId ? { id: s.variantId } : null);
        if (!resolved || !resolved.id) return;
        var props = {};
        if (s.colorName) props['Couleur'] = s.colorName;
        // Variante Shopify = source de vérité (SKU 15W vs …XXX pour 25W)
        if (state.power) props['Puissance'] = powerLabel;
        if (state.warranty === 'yes' && !(WARRANTY && WARRANTY.variantId)) props['Garantie 5 ans'] = 'Oui';
        if (state.engraving === 'yes' && !(ENGRAVING && ENGRAVING.variantId)) props['Gravure personnalisée'] = 'Oui';
        items.push({ id: resolved.id, quantity: 1, properties: props });
      });

      // (legacy) upgrade-charge-rapide-25w retiré — la puissance est une variante produit

      // Garantie 5 ans : ajout produit Shopify si configuré (1 par chargeur)
      if (state.warranty === 'yes' && WARRANTY && WARRANTY.variantId) {
        items.push({
          id: WARRANTY.variantId,
          quantity: state.slots.length,
          properties: { 'Lié à votre pack': 'Garantie 5 ans' }
        });
      }
      // Gravure : ajout produit Shopify si configuré (1 par chargeur)
      if (state.engraving === 'yes' && ENGRAVING && ENGRAVING.variantId) {
        items.push({
          id: ENGRAVING.variantId,
          quantity: state.slots.length,
          properties: { 'Lié à votre pack': 'Gravure' }
        });
      }
      // Rallonge USB-C : ajout produit Shopify si configuré (quantity = state.extras.extension)
      if (state.extras.extension > 0 && EXTENSION && EXTENSION.variantId) {
        items.push({
          id: EXTENSION.variantId,
          quantity: state.extras.extension,
          properties: { 'Lié à votre pack': EXTENSION.title || 'Rallonge USB-C' }
        });
      }
      // Adaptateur 55W : idem
      if (state.extras.adapter > 0 && ADAPTER && ADAPTER.variantId) {
        items.push({
          id: ADAPTER.variantId,
          quantity: state.extras.adapter,
          properties: { 'Lié à votre pack': ADAPTER.title || 'Adaptateur 55W' }
        });
      }

      // Multi-coque support : pour Duo/Famille, on ajoute toutes les coques
      // sélectionnées (1 par chargeur). Pour Solo, fallback sur le legacy single.
      if (state.coqueChoice === 'with') {
        var coquesToAdd = (state.coques && state.coques.length > 0)
          ? state.coques.filter(function (c) { return c && c.variantId; })
          : (state.coqueVariantId ? [{ variantId: state.coqueVariantId, modelLabel: state.coqueModelLabel }] : []);
        coquesToAdd.forEach(function (c) {
          items.push({ id: c.variantId, quantity: 1, properties: { 'Modèle': c.modelLabel || '' } });
        });
      }

      // Pack cadeau offert : ajoute le vrai produit Shopify (gratuit, 0€) au
      // panier en quantité = freeLots (1 pour Duo, 4 pour Famille).
      var giftCountCart = 0;
      if (state.formula === 'duo') giftCountCart = 1;
      else if (state.formula === 'family') giftCountCart = 4;
      if (giftCountCart > 0 && window.AppleComposerGift && window.AppleComposerGift.variantId) {
        items.push({
          id: window.AppleComposerGift.variantId,
          quantity: giftCountCart,
          properties: { 'Offert avec votre pack': 'Oui' }
        });
      }

      if (items.length === 0) {
        window.location.href = redirect;
        return;
      }

      if (triggerBtn) {
        triggerBtn.disabled = true;
        triggerBtn.dataset.origLabel = triggerBtn.textContent;
        triggerBtn.textContent = 'Ajout en cours...';
      }

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: items })
      })
        .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, body: j }; }); })
        .then(function (res) {
          if (res.ok) {
            try { localStorage.removeItem('lpc_build'); } catch (e) {}
            window.location.href = redirect;
          } else {
            console.warn('Composer cart add failed', res.body);
            alert(res.body && res.body.description ? res.body.description : LPCT('add_error'));
            if (triggerBtn) {
              triggerBtn.disabled = false;
              triggerBtn.textContent = triggerBtn.dataset.origLabel || LPCT('add_to_cart');
            }
          }
        })
        .catch(function (err) {
          console.error('Composer fetch failed', err);
          if (triggerBtn) {
            triggerBtn.disabled = false;
            triggerBtn.textContent = triggerBtn.dataset.origLabel || LPCT('add_to_cart');
          }
        });
    }

    function scrollToFinal() {
      // Vise composer-final-inner (le bloc blanc du récap). Offset -16 pour aligner exactement
      // sur le topOffset du sticky-pin (cf-right-sticky pinned at top:16). Évite le saut visuel
      // au moment où sticky kick in.
      var target = root.querySelector('.composer-final-inner') || root.querySelector('[data-composer-final]');
      if (!target) return;
      var top = target.getBoundingClientRect().top + window.scrollY - 16;
      window.scrollTo({ top: top, behavior: 'smooth' });
    }

    // Side récap CTA — scroll to next incomplete step OR scroll to bottom récap when complete.
    if (summaryCta) {
      summaryCta.addEventListener('click', function () {
        if (summaryCta.classList.contains('is-incomplete')) {
          scrollToFirstIncompleteStep();
        } else {
          scrollToFinal();
        }
      });
    }

    // Bottom Apple-style récap CTA — adds the pack to cart si complet, sinon
    // scroll vers la prochaine étape incomplete (même UX que sticky top).
    var cfCtaBtn = root.querySelector('[data-cf-cta]');
    if (cfCtaBtn) {
      cfCtaBtn.addEventListener('click', function () {
        if (cfCtaBtn.classList.contains('is-incomplete')) {
          scrollToFirstIncompleteStep();
          return;
        }
        addPackToCart(cfCtaBtn);
      });
    }

    // Rehydrate slots from live catalog (variants 15W/25W) after localStorage restore
    (function rehydrateSlotsFromCatalog() {
      function allModels() { return (MODELS_TRIO || []).concat(MODELS_SOLO || []); }
      state.slots = (state.slots || []).map(function (s) {
        if (!s || !s.modelId) return s;
        var m = allModels().find(function (mm) { return mm.id === s.modelId; });
        if (!m) return s;
        var colorName = s.colorName;
        var v = colorName ? resolveVariant(m.variants || [], colorName, state.power ? wantedPower() : '15W') : null;
        return Object.assign({}, s, {
          variants: m.variants,
          variantId: v ? v.id : s.variantId,
          image: (v && v.image) ? v.image : (s.image || m.image),
          colorName: colorName || s.colorName
        });
      });
    })();

    render();

    // Auto-scroll initial : si formula pré-sélectionnée via URL, on
    // amène l'utilisateur directement à l'étape Modèles (la formule
    // est déjà cochée, pas besoin de la voir).
    if (_autoScrollAfterInit) {
      setTimeout(function () {
        var slotsCard = root.querySelector('[data-step-slots]');
        if (slotsCard) {
          var top = slotsCard.getBoundingClientRect().top + window.scrollY - 110;
          window.scrollTo({ top: top, behavior: 'smooth' });
        }
      }, 200);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // === Fix bfcache : si l'utilisateur revient en arrière via le bouton du
  // navigateur, Safari/Chrome restorent la page entière depuis le cache
  // back-forward SANS rejouer les scripts. Le bouton "Ajouter au panier"
  // reste alors figé sur "Ajout en cours..." s'il avait été cliqué avant
  // de quitter. On force un reset propre.
  window.addEventListener('pageshow', function (e) {
    if (!e.persisted) return; // restauration bfcache uniquement
    // Reset hard du bouton ATC final
    var cfCtaReset = document.querySelector('[data-cf-cta]');
    if (cfCtaReset) {
      cfCtaReset.disabled = false;
      cfCtaReset.classList.remove('is-disabled');
      delete cfCtaReset.dataset.origLabel;
      cfCtaReset.textContent = LPCT('add_to_cart');
    }
    // Reset hard du bouton sticky top
    var stickyCtaReset = document.querySelector('[data-csb-cta]');
    if (stickyCtaReset) {
      stickyCtaReset.disabled = false;
      stickyCtaReset.textContent = LPCT('complete_arrow');
    }
    // Re-trigger un render complet pour synchroniser tout l'UI avec le state
    // (le state est restauré depuis localStorage, donc render redonne le bon
    // label : "Ajouter au panier" si complete, "Compléter votre pack" sinon).
    if (typeof window.__appleComposerCheckSticky === 'function') {
      window.__appleComposerCheckSticky();
    }
    // Force un render si possible (re-init si on a perdu les listeners)
    var root = document.querySelector('[data-apple-composer]');
    if (root) {
      // Trigger un click event silencieux sur la formula card active pour
      // re-rendre — sinon, plus simple : reload doux du composer en re-init.
      try { init(); } catch (err) { /* ignore */ }
    }
  });
})();
